import { evaluateTemplateValueCollection } from "@ea-lab/reactive-json";
import { noticeStore } from "./noticeStore.js";

/**
 * Reactive-json reaction. YAML usage:
 *
 *   ~~> notice:
 *     type: success         # info | success | warning | error  (default: info)
 *     message: "Sauvegardé"  # may interpolate templates (e.g. ~. fieldName)
 *     duration: 5000         # ms; default 10000
 *
 * Registered in [App.jsx](../App.jsx) under `customPlugins.reaction.notice`.
 */
export const noticeReaction = (props) => {
    const { args, globalDataContext, templateContext } = props;
    if (!args) return;

    const evaluated = evaluateTemplateValueCollection({
        valueToEvaluate: args,
        globalDataContext,
        templateContext,
    });

    const { type, message, duration } = evaluated || {};
    if (message === undefined || message === null) return;

    noticeStore.add({
        type,
        message: typeof message === "string" ? message : String(message),
        duration: typeof duration === "number" ? duration : undefined,
    });
};
